/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { arrayOf, entity, enumeration } from '@gh/core-data';

import { EmailTemplateType } from './email-template-type.enum';

import {
  EmailTemplateAutocompleteListItemDto,
  EmailTemplateDetailsDto,
  EmailTemplateListItemDto,
} from './email-template.dto';
import { EmailTemplatesGridFilter } from './email-template.rest.service';

export const EmailTemplateListItemMapper = entity<EmailTemplateListItemDto>({});

export const EmailTemplateDetailsMapper = entity<EmailTemplateDetailsDto>({
  type: enumeration(EmailTemplateType),
});

export const EmailTemplatesGridFilterMapper = entity<EmailTemplatesGridFilter>({
  type: enumeration(EmailTemplateType),
});

export const EmailTemplateAutocompleteListMapper = arrayOf(entity<EmailTemplateAutocompleteListItemDto>({}));
